<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">资产管理</span>
            <span class="bar-tools">
                <DatePicker v-model="period" type="month" format="yyyy-MM"></DatePicker>
                <Button color="primary" size="s" @click="generateDep" :loading="depLoading">计提折旧</Button>
                <Button size="s" @click="loadList">查询</Button>
            </span>
        </div>
        <div class="margin-top margin-left">
            <Button color="primary" size="s" @click="add">添加</Button>
            <Button size="s" :disabled="checkedList.length < 2" @click="openMerge">合并</Button>
            <Button size="s" :disabled="!checkedList.length" @click="copyOne">复制</Button>
            <Button size="s" :disabled="!checkedList.length" @click="batchRemove">删除</Button>
            <Button size="s" @click="showImport = true">导入</Button>
            <Button size="s" @click="exportCsv">导出</Button>
            <Button size="s" @click="printPage">打印</Button>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:44px"><input type="checkbox" :checked="checkAll" @click="toggleAll"></th>
                    <th style="width:90px">编码</th>
                    <th style="width:120px">资产类别</th>
                    <th style="min-width:130px">资产名称</th>
                    <th style="width:110px">规格型号</th>
                    <th style="width:60px">数量</th>
                    <th style="width:80px">录入期间</th>
                    <th style="width:100px">开始使用日期</th>
                    <th style="width:110px">资产原值</th>
                    <th style="width:90px">税额</th>
                    <th style="width:110px">资产净值</th>
                    <th style="width:100px">本期折旧</th>
                    <th style="width:110px">累计折旧</th>
                    <th style="width:90px">预计使用月份</th>
                    <th style="width:80px">已折旧月份</th>
                    <th style="width:90px">剩余使用月份</th>
                    <th style="width:80px">资产状态</th>
                    <th style="width:70px">处置</th>
                    <th style="width:90px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td align="center"><input type="checkbox" v-model="item._checked"></td>
                    <td>{{item.code}}</td>
                    <td>{{item.typeName}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.spec}}</td>
                    <td align="right">{{item.quantity}}</td>
                    <td>{{item.period}}</td>
                    <td>{{item.startDate}}</td>
                    <td align="right">{{item.originalValue|numFormat}}</td>
                    <td align="right">{{item.taxAmount|numFormat}}</td>
                    <td align="right">{{item.netValue|numFormat}}</td>
                    <td align="right">{{item.currentDepreciation|numFormat}}</td>
                    <td align="right">{{item.accumulatedDepreciation|numFormat}}</td>
                    <td align="right">{{item.useLife}}</td>
                    <td align="right">{{item.depreciatedMonths}}</td>
                    <td align="right">{{item.remainMonths}}</td>
                    <td>{{statusTxt[item.status]}}</td>
                    <td>
                        <span v-if="item.status === 3" class="text-hover">{{item.disposePeriod}}</span>
                        <span v-else class="text-hover" @click="openDispose(item)">处置</span>
                    </td>
                    <td class="actions">
                        <span v-if="!item.splitFlag && !item.splitAssetsId && !item.mergedCheckDate" @click="edit(item)">编辑</span>
                        <span v-if="!item.splitFlag && !item.splitAssetsId && !item.mergedCheckDate" @click="remove(item)">删除</span>
                        <span v-if="item.splitFlag === 1" style="color:#e64c4c" @click="cancelSplitItem(item)">取消拆分</span>
                        <span v-else-if="item.status !== 3 && !item.splitAssetsId" @click="openSplit(item)">拆分</span>
                        <span v-if="item.mergedCheckDate" style="color:#e64c4c" @click="cancelMergedItem(item)">取消合并</span>
                    </td>
                </tr>
                <tr v-if="!datas.length">
                    <td :colspan="19" class="text-center padding">暂无数据</td>
                </tr>
                <tr class="total" v-else>
                    <td colspan="8" align="center">合计</td>
                    <td align="right">{{total('originalValue')|numFormat}}</td>
                    <td align="right">{{total('taxAmount')|numFormat}}</td>
                    <td align="right">{{total('netValue')|numFormat}}</td>
                    <td align="right">{{total('currentDepreciation')|numFormat}}</td>
                    <td align="right">{{total('accumulatedDepreciation')|numFormat}}</td>
                    <td colspan="6"></td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- 资产表单 -->
        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id ? '编辑' : '添加'}}资产</div>
            <div class="form-scroll">
                <Form ref="form" v-width="620" :labelWidth="150" :model="form" :rules="validationRules">
                    <div class="group-title">基本信息</div>
                    <FormItem label="资产编码" prop="code"><input type="text" v-model="form.code"></FormItem>
                    <FormItem label="资产名称" prop="name"><input type="text" v-model="form.name"></FormItem>
                    <FormItem label="资产类别" prop="typeId">
                        <Select v-model="form.typeId" :datas="typeOptions" keyName="id" titleName="name" @change="onTypeChange" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="增加方式">
                        <Select v-model="form.addType" :datas="addTypes" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="开始使用日期">
                        <DatePicker v-model="form.startDate" format="yyyy-MM-dd"></DatePicker>
                    </FormItem>
                    <FormItem label="使用部门">
                        <Select v-model="form.deptId" :datas="deptOptions" keyName="id" titleName="name" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="录入期间">
                        <DatePicker v-model="form.periodDate" type="month" format="yyyy-MM"></DatePicker>
                    </FormItem>
                    <FormItem label="规格型号"><input type="text" v-model="form.spec"></FormItem>
                    <FormItem label="供应商"><input type="text" v-model="form.supplier"></FormItem>
                    <FormItem label="资产数量"><NumberInput v-model="form.quantity" :min="1"></NumberInput></FormItem>
                    <FormItem label="计量单位"><input type="text" v-model="form.unit"></FormItem>
                    <FormItem label="存放地点"><input type="text" v-model="form.location"></FormItem>

                    <div class="group-title">折旧方式</div>
                    <FormItem label="折旧方法">
                        <Select v-model="form.depreciationMethod" :datas="depMethods" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="录入当期是否折旧">
                        <Radio v-model="form.currentPeriodDep" :datas="yesNo" keyName="id" titleName="name"></Radio>
                    </FormItem>
                    <FormItem label="使用人"><input type="text" v-model="form.custodian"></FormItem>

                    <div class="group-title">科目</div>
                    <FormItem label="资产科目">
                        <Select v-model="form.assetSubjectId" :datas="subjectOptions" keyName="id" titleName="name" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="累计折旧科目">
                        <Select v-model="form.depSubjectId" :datas="subjectOptions" keyName="id" titleName="name" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="折旧费用科目">
                        <Select v-model="form.depExpenseSubjectId" :datas="subjectOptions" keyName="id" titleName="name" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="资产清理科目">
                        <Select v-model="form.clearSubjectId" :datas="subjectOptions" keyName="id" titleName="name" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="进项税科目">
                        <Select v-model="form.inputTaxSubjectId" :datas="subjectOptions" keyName="id" titleName="name" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="减值准备科目">
                        <Select v-model="form.impairSubjectId" :datas="subjectOptions" keyName="id" titleName="name" :deletable="false"></Select>
                    </FormItem>
                    <FormItem label="减值准备对方科目">
                        <Select v-model="form.impairCounterSubjectId" :datas="subjectOptions" keyName="id" titleName="name" :deletable="false"></Select>
                    </FormItem>

                    <div class="group-title">资产数据</div>
                    <FormItem label="资产原值" prop="originalValue">
                        <NumberInput v-model="form.originalValue" :precision="2"></NumberInput>
                    </FormItem>
                    <FormItem label="残值率(%)"><NumberInput v-model="form.residualRate" :precision="2" :min="0" :max="100"></NumberInput></FormItem>
                    <FormItem label="预计残值"><input type="text" :value="calcResidual" readonly class="readonly"></FormItem>
                    <FormItem label="预计使用月份" prop="useLife"><NumberInput v-model="form.useLife" :min="1"></NumberInput></FormItem>
                    <FormItem label="已折旧月份"><NumberInput v-model="form.depreciatedMonths" :min="0" :disabled="!!form.id"></NumberInput></FormItem>
                    <FormItem label="剩余使用月份"><input type="text" :value="calcRemain" readonly class="readonly"></FormItem>
                    <FormItem label="累计折旧"><NumberInput v-model="form.accumulatedDepreciation" :precision="2" :disabled="!!form.id"></NumberInput></FormItem>
                    <FormItem label="本年累计折旧"><input type="text" :value="form.yearDepreciation" readonly class="readonly"></FormItem>
                    <FormItem label="以前年度累计折旧"><input type="text" :value="calcPrevYear" readonly class="readonly"></FormItem>
                    <FormItem label="每月折旧额"><input type="text" :value="calcMonthDep" readonly class="readonly"></FormItem>
                    <FormItem label="减值准备"><NumberInput v-model="form.impairment" :precision="2"></NumberInput></FormItem>
                    <FormItem label="税额"><NumberInput v-model="form.taxAmount" :precision="2"></NumberInput></FormItem>
                    <FormItem label="备注"><textarea rows="2" v-model="form.remark"></textarea></FormItem>
                </Form>
            </div>
            <div class="text-center margin-top">
                <Button color="green" @click="submit" :loading="loading">{{form.id ? '更新' : '保存'}}</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>

        <!-- 资产合并 -->
        <Modal v-model="showMerge">
            <div slot="header">资产合并（{{mergeList.length}} 条 → 1 条）</div>
            <div class="padding">
                <div v-if="mergeCheckError" style="color:#e64c4c" class="margin-bottom">{{mergeCheckError}}</div>
                <table class="grid">
                    <thead>
                    <tr>
                        <th>编码</th><th>资产名称</th><th>数量</th><th>资产原值</th><th>累计折旧</th><th>本年累计折旧</th><th>减值准备</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in mergeList" :key="item.id">
                        <td>{{item.code}}</td>
                        <td>{{item.name}}</td>
                        <td align="right">{{item.quantity}}</td>
                        <td align="right">{{item.originalValue|numFormat}}</td>
                        <td align="right">{{item.accumulatedDepreciation|numFormat}}</td>
                        <td align="right">{{item.yearDepreciation|numFormat}}</td>
                        <td align="right">{{item.impairment|numFormat}}</td>
                    </tr>
                    <tr class="total">
                        <td colspan="2" align="center">合并后（数量/金额求和）</td>
                        <td align="right">{{mergeSum('quantity')}}</td>
                        <td align="right">{{mergeSum('originalValue')|numFormat}}</td>
                        <td align="right">{{mergeSum('accumulatedDepreciation')|numFormat}}</td>
                        <td align="right">{{mergeSum('yearDepreciation')|numFormat}}</td>
                        <td align="right">{{mergeSum('impairment')|numFormat}}</td>
                    </tr>
                    </tbody>
                </table>
                <Form class="margin-top" v-width="360" :labelWidth="120">
                    <FormItem label="合并后编码">
                        <input type="text" v-model="mergeCode">
                    </FormItem>
                </Form>
                <div class="text-warning">合并后可通过主卡「取消合并」恢复；类别/增加方式/规格/供应商/部门/录入期间/开始使用日期/残值率/预计使用月份必须一致。</div>
            </div>
            <div class="text-center">
                <Button color="green" @click="submitMerge" :loading="mergeLoading">确认合并</Button>
                <Button @click="showMerge=false">取消</Button>
            </div>
        </Modal>

        <!-- 资产导入 -->
        <Modal v-model="showImport">
            <div slot="header">资产导入</div>
            <div class="padding">
                <div>第一步：请点击下面的链接下载Excel模板，并按照模板填写信息</div>
                <div><a class="text-hover" style="color:#3b91ff" @click="downloadTemplate">下载模板</a></div>
                <div class="margin-top">第二步：导入Excel模板文件</div>
                <input type="file" ref="importFile" accept=".xlsx,.xls">
                <div v-if="importError" style="color:#e64c4c" class="margin-top">{{importError}}</div>
            </div>
            <div class="text-center">
                <Button color="primary" @click="submitImport" :loading="importLoading">导入</Button>
                <Button @click="showImport=false">取消</Button>
            </div>
        </Modal>

        <!-- 处置 -->
        <Modal v-model="showDispose">
            <div slot="header">资产处置 - {{disposeForm.name}}</div>
            <Form ref="disposeForm" v-width="420" :labelWidth="110" :model="disposeForm" :rules="disposeRules">
                <FormItem label="处置期间" prop="period">
                    <DatePicker v-model="disposeForm.periodDate" type="month" format="yyyy-MM"></DatePicker>
                </FormItem>
                <FormItem label="处置日期">
                    <DatePicker v-model="disposeForm.date" format="yyyy-MM-dd"></DatePicker>
                </FormItem>
                <FormItem label="处置收入"><NumberInput v-model="disposeForm.amount" :precision="2"></NumberInput></FormItem>
                <FormItem label="当前净值"><input type="text" :value="disposeForm.netValue" readonly class="readonly"></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submitDispose" :loading="disposeLoading">确定</Button>
                <Button @click="showDispose=false">取消</Button>
            </div>
        </Modal>

        <!-- 资产拆分 -->
        <Modal v-model="showSplit" :hasCloseIcon="true" v-width="760">
            <div slot="header">资产拆分 - {{splitEntity && splitEntity.name}}</div>
            <div class="padding">
                <Form inline :labelWidth="90">
                    <FormItem label="拆分数量"><NumberInput v-model="splitQuantity" :min="2" :max="999" style="width:120px" @change="rebuildRows"></NumberInput></FormItem>
                    <FormItem label="拆分期间"><DatePicker v-model="splitDate" type="month" format="yyyy-MM"></DatePicker></FormItem>
                </Form>
                <table class="grid">
                    <thead>
                    <tr><th>编码</th><th>数量</th><th>资产原值</th><th>累计折旧</th><th>本年累计折旧</th><th>预计残值</th></tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, idx) in splitRows" :key="idx">
                        <td>{{row.code}}</td>
                        <td align="right">{{row.quantity}}</td>
                        <td align="right"><NumberInput v-model="row.originalValue" :precision="2" style="width:110px" @change="ratioRows"></NumberInput></td>
                        <td align="right"><input type="text" :value="row.accumulatedDepreciation" readonly class="readonly" style="width:100px;text-align:right"></td>
                        <td align="right"><input type="text" :value="row.yearDepreciation" readonly class="readonly" style="width:100px;text-align:right"></td>
                        <td align="right"><input type="text" :value="row.expectResidual" readonly class="readonly" style="width:100px;text-align:right"></td>
                    </tr>
                    <tr class="total">
                        <td colspan="2" align="center">合计</td>
                        <td align="right">{{splitSum('originalValue')|numFormat}}</td>
                        <td align="right">{{splitSum('accumulatedDepreciation')|numFormat}}</td>
                        <td align="right">{{splitSum('yearDepreciation')|numFormat}}</td>
                        <td align="right">{{splitSum('expectResidual')|numFormat}}</td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="splitErrors.length" style="color:#e64c4c" class="margin-top">{{splitErrors.join('；')}}</div>
                <div class="text-warning margin-top">拆分后每张卡片编码为「编码+拆N」，可点「取消拆分」还原；拆分期间（含）之后已计提折旧则不允许拆分。</div>
            </div>
            <div class="text-center">
                <Button color="green" @click="submitSplit" :loading="splitLoading">确认拆分</Button>
                <Button @click="showSplit=false">取消</Button>
            </div>
        </Modal>
    </app-content>
</template>

<script>
const emptyForm = {
    id: null, code: '', name: '', typeId: null, addType: '购入',
    startDate: null, deptId: null, periodDate: null, spec: '', supplier: '',
    quantity: 1, unit: '', location: '', custodian: '',
    depreciationMethod: '平均年限法', currentPeriodDep: 0,
    assetSubjectId: null, depSubjectId: null, depExpenseSubjectId: null,
    clearSubjectId: null, inputTaxSubjectId: null, impairSubjectId: null, impairCounterSubjectId: null,
    originalValue: 0, residualRate: 5, useLife: 60, depreciatedMonths: 0,
    accumulatedDepreciation: 0, yearDepreciation: 0, impairment: 0, taxAmount: 0,
    remark: ''
};

const COLS = ['code', 'name', 'typeName', 'spec', 'quantity', 'period', 'startDate',
    'originalValue', 'taxAmount', 'netValue', 'currentDepreciation', 'accumulatedDepreciation',
    'useLife', 'depreciatedMonths', 'remainMonths'];

export default {
    name: 'Assets',
    data() {
        const now = new Date();
        return {
            datas: [],
            period: now,
            today: now,
            showForm: false,
            showDispose: false,
            showMerge: false,
            showImport: false,
            loading: false,
            depLoading: false,
            disposeLoading: false,
            mergeLoading: false,
            importLoading: false,
            mergeCode: '',
            mergeCheckError: '',
            importError: '',
            form: Object.assign({}, emptyForm),
            disposeForm: { id: null, name: '', netValue: 0, periodDate: now, date: now, amount: 0 },
            showSplit: false,
            splitLoading: false,
            splitEntity: null,
            splitQuantity: 2,
            splitDate: now,
            splitRows: [],
            mergeList: [],
            typeOptions: [],
            subjectOptions: [],
            deptOptions: [],
            addTypes: ['购入', '自建', '投资投入', '捐赠', '盘盈', '其他'],
            depMethods: ['平均年限法', '不计提折旧'],
            yesNo: [{ id: 1, name: '是' }, { id: 0, name: '否' }],
            statusTxt: { 1: '在用', 2: '已提足', 3: '已处置' },
            validationRules: { required: ['code', 'name', 'typeId', 'originalValue', 'useLife'] },
            disposeRules: { required: ['periodDate'] }
        };
    },
    computed: {
        checkAll() {
            return this.datas.length > 0 && this.datas.every(d => d._checked);
        },
        checkedList() {
            return this.datas.filter(d => d._checked);
        },
        calcResidual() {
            return (Number(this.form.originalValue || 0) * Number(this.form.residualRate || 0) / 100).toFixed(2);
        },
        calcRemain() {
            return Math.max(0, Number(this.form.useLife || 0) - Number(this.form.depreciatedMonths || 0));
        },
        calcPrevYear() {
            return (Number(this.form.accumulatedDepreciation || 0) - Number(this.form.yearDepreciation || 0)).toFixed(2);
        },
        calcMonthDep() {
            const dep = Number(this.form.originalValue || 0) - Number(this.calcResidual) - Number(this.form.impairment || 0);
            const m = Number(this.form.useLife || 0) || 1;
            return (Math.max(0, dep) / m).toFixed(2);
        },
        splitErrors() {
            const e = this.splitEntity;
            if (!e || !this.splitRows.length) return [];
            const errs = [];
            const sum = f => this.splitRows.reduce((s, r) => s + Number(r[f] || 0), 0);
            if (Math.abs(sum('originalValue') - Number(e.originalValue || 0)) > 0.005) errs.push('分录「原值合计」与拆分前「资产原值」不一致');
            if (Math.abs(sum('expectResidual') - Number(e.residualValue || 0)) > 0.005) errs.push('分录「预计残值合计」与拆分前「资产预计残值」不一致');
            return errs;
        }
    },
    watch: {
        showForm(val) { if (!val) this.form = Object.assign({}, emptyForm); }
    },
    methods: {
        fmtPeriod(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        },
        fmtDate(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        },
        loadOptions() {
            this.$api.assets.assets.options().then(({ data }) => {
                this.typeOptions = data.types || [];
                this.deptOptions = (data.depts || []).map(d => ({ id: d.id, name: d.code ? `${d.code} ${d.name}` : d.name }));
                this.subjectOptions = (data.subjects || []).map(s => ({ id: s.id, name: s.code ? `${s.code} ${s.name}` : s.name }));
            });
        },
        loadList() {
            this.$api.assets.assets.list({ period: this.fmtPeriod(this.period) }).then(({ data }) => {
                this.datas = (data || []).map(d => Object.assign({ _checked: false }, d));
            });
        },
        onTypeChange(typeId) {
            const t = this.typeOptions.find(t => t.id === typeId);
            if (!t) return;
            if (!this.form.id) {
                this.form.depreciationMethod = t.depreciationMethod || this.form.depreciationMethod;
                this.form.useLife = t.useLife || this.form.useLife;
                this.form.residualRate = t.residualRate == null ? this.form.residualRate : t.residualRate;
                this.form.assetSubjectId = t.assetSubjectId || this.form.assetSubjectId;
                this.form.depSubjectId = t.depSubjectId || this.form.depSubjectId;
            }
        },
        add() {
            this.form = Object.assign({}, emptyForm, { periodDate: new Date(), startDate: new Date() });
            this.showForm = true;
        },
        edit(item) {
            const f = Object.assign({}, emptyForm, item);
            f.periodDate = item.period ? new Date(item.period + '-01') : new Date();
            f.startDate = item.startDate ? new Date(item.startDate) : null;
            this.form = f;
            this.showForm = true;
        },
        submit() {
            if (!this.$refs.form.valid().result) return;
            const payload = Object.assign({}, this.form);
            payload.period = this.fmtPeriod(payload.periodDate);
            payload.startDate = this.fmtDate(payload.startDate);
            delete payload.periodDate;
            this.loading = true;
            this.$api.assets.assets[payload.id ? 'update' : 'save'](payload).then(() => {
                this.loading = false;
                this.showForm = false;
                this.loadList();
                this.$Message.success('保存成功');
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm(`确认删除「${item.name}」?`).then(() => {
                this.$api.assets.assets.delete(item.id).then(() => this.loadList());
            });
        },
        batchRemove() {
            const ids = this.checkedList.map(d => d.id);
            this.$Confirm(`确认删除选中的 ${ids.length} 项资产?`).then(() => {
                Promise.all(ids.map(id => this.$api.assets.assets.delete(id))).then(() => this.loadList());
            });
        },
        copyOne() {
            const list = this.checkedList;
            Promise.all(list.map(d => this.$api.assets.assets.copy(d.id))).then(() => {
                this.loadList();
                this.$Message.success(`已复制 ${list.length} 项资产`);
            });
        },
        batchCopy() {
            Promise.all(this.checkedList.map(d => this.$api.assets.assets.copy(d.id))).then(() => {
                this.loadList();
                this.$Message.success('复制成功');
            });
        },
        notOpen(name) {
            this.$Message.info(`${name}功能暂未开放`);
        },
        openMerge() {
            const list = this.checkedList;
            // 对齐商业版：类别/增加方式/规格/供应商/部门/录入期间/开始使用日期/残值率/预计使用月份 必须一致
            const same = (field, label) => {
                const first = list[0][field] == null ? '' : String(list[0][field]);
                return list.every(d => (d[field] == null ? '' : String(d[field])) === first) ? null : label;
            };
            const diff = ['typeId:资产类别', 'addType:增加方式', 'spec:规格型号', 'supplier:供应商', 'deptId:使用部门', 'period:录入期间', 'startDate:开始使用日期', 'residualRate:残值率', 'useLife:预计使用月份']
                .map(x => { const [f, label] = x.split(':'); return same(f, label); }).filter(Boolean);
            this.mergeCheckError = diff.length ? `所选资产的「${diff.join('、')}」不一致，不能合并~` : '';
            this.mergeList = list;
            this.mergeCode = list[0].code + '合1';
            this.showMerge = true;
        },
        mergeSum(field) {
            return (this.mergeList || []).reduce((s, d) => s + Number(d[field] || 0), 0);
        },
        submitMerge() {
            if (this.mergeCheckError) return;
            this.mergeLoading = true;
            this.$api.assets.assets.merge({
                ids: this.mergeList.map(d => d.id),
                code: this.mergeCode
            }).then(({ data }) => {
                this.mergeLoading = false;
                this.showMerge = false;
                this.loadList();
                this.$Message.success(`合并成功：${data.code} ${data.name}`);
            }).catch(() => { this.mergeLoading = false; });
        },
        downloadTemplate() {
            window.open('/api/assets/template');
        },
        submitImport() {
            const input = this.$refs.importFile;
            if (!input.files || !input.files.length) {
                this.importError = '请先选择文件';
                return;
            }
            const fd = new FormData();
            fd.append('file', input.files[0]);
            this.importLoading = true;
            this.importError = '';
            this.$api.assets.assets.importData(fd).then(({ msg }) => {
                this.importLoading = false;
                this.showImport = false;
                this.loadList();
                this.$Message.success(msg || '导入成功');
            }).catch(() => { this.importLoading = false; });
        },
        generateDep() {
            this.depLoading = true;
            this.$api.assets.assets.generateDepreciation(this.fmtPeriod(this.period)).then(({ msg }) => {
                this.depLoading = false;
                this.$Message.success(msg || '计提完成');
                this.loadList();
            }).catch(() => { this.depLoading = false; });
        },
        openDispose(item) {
            this.disposeForm = {
                id: item.id, name: item.name, netValue: item.netValue,
                periodDate: new Date(), date: new Date(), amount: 0
            };
            this.showDispose = true;
        },
        submitDispose() {
            if (!this.$refs.disposeForm.valid().result) return;
            this.disposeLoading = true;
            this.$api.assets.assets.dispose({
                id: this.disposeForm.id,
                period: this.fmtPeriod(this.disposeForm.periodDate),
                date: this.fmtDate(this.disposeForm.date),
                amount: this.disposeForm.amount
            }).then(() => {
                this.disposeLoading = false;
                this.showDispose = false;
                this.loadList();
                this.$Message.success('处置成功');
            }).catch(() => { this.disposeLoading = false; });
        },
        // ==================== 拆分 / 取消拆分 / 取消合并 ====================
        openSplit(item) {
            if (item.status === 3) { this.$Message.warn('已处置资产不允许拆分~'); return; }
            this.splitEntity = item;
            this.splitQuantity = 2;
            this.splitDate = this.period;
            this.showSplit = true;
            this.rebuildRows();
        },
        rebuildRows() {
            const e = this.splitEntity;
            if (!e) return;
            const t = Math.max(2, Math.min(999, Number(this.splitQuantity) || 2));
            const r = Math.max(1, Number(e.quantity) || 1);
            const ov = Number(e.originalValue) || 0;
            const acc = Number(e.accumulatedDepreciation) || 0;
            const yd = Number(e.yearDepreciation) || 0;
            const res = Number(e.residualValue) || 0;
            const p = r > t ? Math.floor(r / t) : 1;
            const f = r > t ? r % t : 0;
            const qty = [];
            for (let i = 0; i < t; i++) qty.push(p + (i === 0 ? f : 0));
            const qSum = qty.reduce((s, q) => s + q, 0) || 1;
            const rows = [];
            let accUsed = 0, ydUsed = 0, resUsed = 0, ovUsed = 0;
            for (let i = 0; i < t; i++) {
                const last = i === t - 1;
                const rowOv = last ? +(ov - ovUsed).toFixed(2) : +(ov * qty[i] / qSum).toFixed(2);
                const rowAcc = last ? +(acc - accUsed).toFixed(2) : +(acc * rowOv / (ov || 1)).toFixed(2);
                const rowYd = last ? +(yd - ydUsed).toFixed(2) : +(yd * rowOv / (ov || 1)).toFixed(2);
                const rowRes = last ? +(res - resUsed).toFixed(2) : +(res * rowOv / (ov || 1)).toFixed(2);
                ovUsed += rowOv; accUsed += rowAcc; ydUsed += rowYd; resUsed += rowRes;
                rows.push({
                    code: e.code + '拆' + (i + 1), quantity: qty[i],
                    originalValue: rowOv, accumulatedDepreciation: rowAcc,
                    yearDepreciation: rowYd, expectResidual: rowRes
                });
            }
            this.splitRows = rows;
        },
        ratioRows() {
            const e = this.splitEntity;
            if (!e || !this.splitRows.length) return;
            const ov = Number(e.originalValue) || 0;
            const acc = Number(e.accumulatedDepreciation) || 0;
            const yd = Number(e.yearDepreciation) || 0;
            const res = Number(e.residualValue) || 0;
            const n = this.splitRows.length;
            let accUsed = 0, ydUsed = 0, resUsed = 0;
            this.splitRows.forEach((row, i) => {
                const rowOv = Number(row.originalValue) || 0;
                if (i < n - 1 && ov > 0) {
                    row.accumulatedDepreciation = +(acc * rowOv / ov).toFixed(2);
                    row.yearDepreciation = +(yd * rowOv / ov).toFixed(2);
                    row.expectResidual = +(res * rowOv / ov).toFixed(2);
                    accUsed += row.accumulatedDepreciation;
                    ydUsed += row.yearDepreciation;
                    resUsed += row.expectResidual;
                } else if (i === n - 1) {
                    row.accumulatedDepreciation = +(acc - accUsed).toFixed(2);
                    row.yearDepreciation = +(yd - ydUsed).toFixed(2);
                    row.expectResidual = +(res - resUsed).toFixed(2);
                }
            });
        },
        splitSum(field) {
            return this.splitRows.reduce((s, r) => s + Number(r[field] || 0), 0);
        },
        submitSplit() {
            if (!this.splitEntity) return;
            if (this.splitErrors.length) { this.$Message.error(this.splitErrors.join('；')); return; }
            const splitDate = this.fmtPeriod(this.splitDate);
            if (!splitDate) { this.$Message.error('请选择拆分期间~'); return; }
            this.splitLoading = true;
            const rows = this.splitRows.map(r => ({
                quantity: r.quantity,
                originalValue: r.originalValue,
                accumulatedDepreciation: r.accumulatedDepreciation,
                yearDepreciation: r.yearDepreciation,
                expectResidual: r.expectResidual
            }));
            this.$api.assets.assets.split(this.splitEntity.id, splitDate, rows).then(() => {
                this.splitLoading = false;
                this.showSplit = false;
                this.loadList();
                this.$Message.success('拆分成功');
            }).catch(() => { this.splitLoading = false; });
        },
        cancelSplitItem(item) {
            this.$Confirm('确认取消拆分? 拆分产生的子卡片将被删除，主卡片还原。').then(() => {
                this.$api.assets.assets.cancelSplit(item.id).then(() => {
                    this.loadList();
                    this.$Message.success('已取消拆分');
                });
            });
        },
        cancelMergedItem(item) {
            this.$Confirm('确认取消合并? 被并入的卡片将恢复显示，主卡片还原为合并前。').then(() => {
                this.$api.assets.assets.cancelMerged(item.id).then(() => {
                    this.loadList();
                    this.$Message.success('已取消合并');
                });
            });
        },
        toggleAll() {
            const v = !this.checkAll;
            this.datas.forEach(d => { d._checked = v; });
        },
        total(field) {
            return this.datas.reduce((s, d) => s + Number(d[field] || 0), 0);
        },
        exportCsv() {
            const head = ['编码', '资产类别', '资产名称', '规格型号', '数量', '录入期间', '开始使用日期',
                '资产原值', '税额', '资产净值', '本期折旧', '累计折旧', '预计使用月份', '已折旧月份', '剩余使用月份', '资产状态'];
            const keys = ['code', 'typeName', 'name', 'spec', 'quantity', 'period', 'startDate',
                'originalValue', 'taxAmount', 'netValue', 'currentDepreciation', 'accumulatedDepreciation',
                'useLife', 'depreciatedMonths', 'remainMonths'];
            const rows = this.datas.map(d => keys.map(k => (k === 'status' ? this.statusTxt[d.status] : d[k])));
            rows.push(['合计'].concat(keys.slice(1).map(k => (['quantity', 'originalValue', 'taxAmount', 'netValue', 'currentDepreciation', 'accumulatedDepreciation'].includes(k) ? this.total(k) : ''))));
            const csv = [head].concat(rows).map(r => r.map(c => `"${c == null ? '' : c}"`).join(',')).join('\r\n');
            this.download(`资产列表_${this.fmtPeriod(this.period)}.csv`, '\ufeff' + csv);
        },
        download(name, content) {
            const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name;
            a.click();
            URL.revokeObjectURL(a.href);
        },
        printPage() { window.print(); }
    },
    mounted() {
        this.loadOptions();
        this.loadList();
    }
};
</script>

<style scoped lang="less">
    .bar-tools {
        margin-left: 20px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .grid {
        width: 100%;
        border-collapse: collapse;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
            white-space: nowrap;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:nth-child(even) { background-color: #fafafa; }
        tbody tr:hover { background-color: #f0f6ff; }

        .total td {
            background-color: #f5f5f5;
            font-weight: bold;
        }
    }

    .actions span {
        margin-right: 8px;
        cursor: pointer;
        color: #3b91ff;
    }

    .text-hover { cursor: pointer; }

    .group-title {
        font-weight: bold;
        margin: 12px 0 6px;
        padding-left: 6px;
        border-left: 3px solid #3b91ff;
    }

    .form-scroll {
        max-height: calc(100vh - 180px);
        overflow-y: auto;
        padding-right: 10px;
    }

    .readonly {
        background-color: #f5f5f5;
        border: 1px solid #e2e2e2;
        height: 32px;
        width: 100%;
        padding: 0 8px;
        box-sizing: border-box;
    }
</style>
